/* Mon p'tit pitchou — cadeaux offerts ajoutés automatiquement au panier
   Un véhicule électrique dans le panier => le(s) cadeau(x) Lean Toys de son palier, à 0 €.
   Paliers sur le prix unitaire du véhicule :
   - moins de 300 € : talkies-walkies (1 cadeau)
   - 300 à 499,99 € : feu tricolore + talkies-walkies (2 cadeaux)
   - 500 € et plus  : feu tricolore + 5 panneaux + talkies-walkies (3 cadeaux)
   Les véhicules Aosom / AIYAPLAY (SKU « AO- ») n'ont pas de cadeau.
   (panneau STOP et porte-clés ne sont plus offerts : ils restent dans la liste pour être retirés des paniers)
   Le script recalcule les cadeaux à chaque changement du panier et juste avant le paiement. */
(function () {
  'use strict';
  if (window.__pitchouCadeaux) return;
  window.__pitchouCadeaux = true;

  var G = {
    stop: 54402325283144,
    cles: 54402325315912,
    talkies: 54402325348680,
    feu: 54402325381448,
    panneaux: 54402325479752
  };
  var IDS = Object.keys(G).map(function (k) { return G[k]; });
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var fetchOrig = window.fetch.bind(window);
  var enCours = null, aRefaire = false;

  function palier(prixCentimes) {
    if (prixCentimes < 30000) return [G.talkies];
    if (prixCentimes < 50000) return [G.feu, G.talkies];
    return [G.feu, G.panneaux, G.talkies];
  }
  function estVehicule(item) {
    var t = (item.product_type || '').toLowerCase();
    if (String(item.sku || '').indexOf('AO-') === 0) return false;
    return IDS.indexOf(item.variant_id) === -1 && t.indexOf('électrique') > -1 && t.indexOf('adiocommand') === -1;
  }

  function synchroniser() {
    if (enCours) { aRefaire = true; return enCours; }
    enCours = fetchOrig(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (panier) {
        var voulu = {}, actuel = {};
        IDS.forEach(function (id) { voulu[id] = 0; actuel[id] = 0; });
        panier.items.forEach(function (it) {
          if (IDS.indexOf(it.variant_id) > -1) { actuel[it.variant_id] += it.quantity; return; }
          if (estVehicule(it)) palier(it.original_price).forEach(function (id) { voulu[id] += it.quantity; });
        });
        var aAjouter = [], aMaj = {}, change = false;
        IDS.forEach(function (id) {
          if (voulu[id] === actuel[id]) return;
          change = true;
          if (actuel[id] === 0) aAjouter.push({ id: id, quantity: voulu[id], properties: { _cadeau: '1' } });
          else aMaj[id] = voulu[id];
        });
        if (!change) return false;
        var p = Promise.resolve();
        if (Object.keys(aMaj).length) {
          p = p.then(function () {
            return fetchOrig(root + 'cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates: aMaj }) });
          });
        }
        if (aAjouter.length) {
          p = p.then(function () {
            return fetchOrig(root + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: aAjouter }) });
          });
        }
        return p.then(function () { return true; });
      })
      .catch(function () { return false; })
      .then(function (change) {
        enCours = null;
        if (aRefaire) { aRefaire = false; return synchroniser().then(function (c2) { return change || c2; }); }
        return change;
      });
    return enCours;
  }

  function rafraichirAffichage() {
    if (document.body.classList.contains('gabarit-cart')) { location.reload(); return Promise.resolve(); }
    return fetchOrig(root + '?sections=panier-tiroir', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var ancien = document.querySelector('[data-tiroir-panier]');
        if (!ancien || !d['panier-tiroir']) return;
        var tmp = document.createElement('div'); tmp.innerHTML = d['panier-tiroir'];
        var neuf = tmp.querySelector('[data-tiroir-panier]');
        if (!neuf) return;
        if (ancien.classList.contains('est-ouvert')) neuf.classList.add('est-ouvert');
        ancien.replaceWith(neuf);
        return fetchOrig(root + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
          Array.prototype.forEach.call(document.querySelectorAll('[data-compteur]'), function (el) { el.textContent = c.item_count; el.hidden = !c.item_count; });
        });
      })
      .catch(function () {});
  }

  function synchroEtAffiche() {
    return synchroniser().then(function (change) { if (change) return rafraichirAffichage(); });
  }

  /* Après chaque modification du panier faite par le thème */
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = fetchOrig(input, init);
    if (/\/cart\/(add|change|update|clear)(\.js)?/.test(url)) {
      p.then(function () { setTimeout(synchroEtAffiche, 50); }, function () {});
    }
    return p;
  };

  /* Juste avant le paiement : on vérifie les cadeaux, puis on envoie */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    var sub = e.submitter;
    var versPaiement = (sub && sub.name === 'checkout') || f.querySelector('[name="checkout"]');
    if (!versPaiement || f.dataset.cadeauxOk === '1') return;
    if (!/\/cart/.test(f.getAttribute('action') || '')) return;
    e.preventDefault();
    if (sub) sub.setAttribute('aria-busy', 'true');
    synchroniser().then(function () {
      f.dataset.cadeauxOk = '1';
      if (!f.querySelector('input[type=hidden][name="checkout"]')) {
        var h = document.createElement('input'); h.type = 'hidden'; h.name = 'checkout'; h.value = '1'; f.appendChild(h);
      }
      f.submit();
    });
  }, true);

  /* Au chargement de chaque page */
  synchroEtAffiche();
})();
